// extracted by mini-css-extract-plugin
export default {"container":"form-layout_container","card":"form-layout_card","title":"form-layout_title"};